query dailyAnalyticsImpressions($input: GetDailyAnalyticsImpressionInput!) {
  dailyAnalyticsImpressions: dailyAnalyticsImpressions(input: $input) {
    impressions
    createdAt
  }
}
